import { render, staticRenderFns } from "./SwiperCarrouselSlide.vue?vue&type=template&id=63b01ae5&scoped=true&"
import script from "./SwiperCarrouselSlide.vue?vue&type=script&lang=js&"
export * from "./SwiperCarrouselSlide.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCarrouselSlide.vue?vue&type=style&index=0&id=63b01ae5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b01ae5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResponsivePicture: require('/codebuild/output/src3208117147/src/studio-frank/components/global/ResponsivePicture.vue').default})
